export default "__VITE_ASSET__DUjgT1X4__"